import PropTypes from "prop-types";

function Facility({ icon, position }) {
    return (
        <div
            aria-hidden="true"
            className="facilityIconWrapper"
            style={{
                "--topDesktop": `${position.desktop.y}%`,
                "--leftDesktop": `${position.desktop.x}%`,
                "--topMobile": `${position.mobile.y}px`,
                "--leftMobile": `${position.mobile.x}px`
            }}
        >
            <img className="facilityIcon" src={`${process.env.PUBLIC_URL}/assets/${icon}`} alt=""/>
        </div>
    );
}

Facility.propTypes = {
    icon: PropTypes.string.isRequired,
    position: PropTypes.object.isRequired
};

export default Facility;
